import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorStrings } from 'src/app/constants/form.constants';
import { Alert } from 'src/app/interfaces/alert';
import {
  AuthManagerService,
  ClaimAccountParams,
} from 'src/app/services/auth-manager/auth-manager.service';

@Component({
  selector: 'app-claim-account',
  templateUrl: './claim-account.component.html',
  styleUrls: ['./claim-account.component.scss'],
})
export class ClaimAccountComponent implements OnInit {
  hideConfirmPassword: boolean = true;
  hidePassword: boolean = true;

  public loading = false;
  public errorStrings = ErrorStrings;
  public alert: Alert = null;
  public model = {
    password: '',
  };

  private _emailAddress: string;
  private _emailVerificationCode: string;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _authManager: AuthManagerService,
    private _router: Router
  ) {}

  ngOnInit(): void {
    const queryParams = this._activatedRoute.snapshot.queryParams;

    if (
      !queryParams ||
      (queryParams && !queryParams.emailAddress) ||
      (queryParams && !queryParams.evc)
    ) {
      this.alert = {
        type: 'danger',
        message:
          'An error has occurred, the URL is invalid! Please try to open the claim email again, ' +
          'in case the issue still persist please feel free to contact us.',
      };
    } else {
      this._emailAddress = queryParams.emailAddress;
      this._emailVerificationCode = queryParams.evc;
    }
  }

  public claimAccount() {
    this.closeAlert();
    this.loading = true;

    const claimAccountParams: ClaimAccountParams = {
      password: this.model.password,
      emailAddress: this._emailAddress,
      emailVerificationCode: this._emailVerificationCode,
    };

    this._authManager
      .claimAccount(claimAccountParams)
      .subscribe(
        () => {
          this.alert = {
            type: 'success',
            message:
              "Your account was activated, you'll get redirected in a few seconds!",
          };

          setTimeout(() => {
            this._router.navigate(['/login']);
          }, 2000);
        },
        (err) => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            this.alert = {
              type: 'danger',
              message: 'Something went wrong!',
            };
          } else if (err instanceof HttpErrorResponse && err.status === 409) {
            // User already registered: Redirect to login form
            this.alert = {
              type: 'success',
              message: "Success! You'll get redirected in a few seconds!",
            };

            setTimeout(() => {
              this._router.navigate(['/login'], {
                queryParams: { email: this._emailAddress },
              });
            }, 2000);
          } else {
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.',
            };
          }
        }
      )
      .add(() => {
        this.loading = false;
      });
  }

  public closeAlert() {
    this.alert = null;
  }
}
